
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class SalesOrderService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.so_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_SO_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static getSalesOrderPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getSalesOrderPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initSalesOrderModule(input, responseCallBack, errorCallBack) {
    this.method("initSalesOrderModule", input, responseCallBack, errorCallBack);
  }
  static readSalesOrder(input, responseCallBack, errorCallBack) {
    this.method("readSalesOrder", input, responseCallBack, errorCallBack);
  }
  static createSalesOrder(input, responseCallBack, errorCallBack) {
    this.method("createSalesOrder", input, responseCallBack, errorCallBack);
  }
  static updateSalesOrder(input, responseCallBack, errorCallBack) {
    this.method("updateSalesOrder", input, responseCallBack, errorCallBack);
  }
  static updateSalesOrderAfterApproval(input, responseCallBack, errorCallBack) {
    this.method(
      "updateSalesOrderAfterApproval",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePickTicketEntryThenPrintPickTicket(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePickTicketEntryThenPrintPickTicket",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createAndApproveSalesOrder(input, responseCallBack, errorCallBack) {
    this.method(
      "createAndApproveSalesOrder",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateAndApproveSalesOrder(input, responseCallBack, errorCallBack) {
    this.method(
      "updateAndApproveSalesOrder",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelSalesOrder(input, responseCallBack, errorCallBack) {
    this.method("cancelSalesOrder", input, responseCallBack, errorCallBack);
  }
  static createSalesOrderImage(input, responseCallBack, errorCallBack) {
    this.method(
      "createSalesOrderImage",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateSalesOrderDocumentName(input, responseCallBack, errorCallBack) {
    this.method(
      "updateSalesOrderDocumentName",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getFabricStyleSalePrice(input, responseCallBack, errorCallBack) {
    this.method(
      "getFabricStyleSalePrice",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelSalesOrderLine(input, responseCallBack, errorCallBack) {
    this.method("cancelSalesOrderLine", input, responseCallBack, errorCallBack);
  }

  static unLockSalesOrder(input, responseCallBack, errorCallBack) {
    this.method("unLockSalesOrder", input, responseCallBack, errorCallBack);
  }
  static salesOrderImageUpload(input, responseCallBack, errorCallBack) {
    this.method(
      "salesOrderImageUpload",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePurchaseorderForSalesOrder(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePurchaseorderForSalesOrder",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static fetchSalesOrderMailCustomerDefaultInfoBean(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "fetchSalesOrderMailCustomerDefaultInfoBean",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static sendSalesOrderCustomerMail(input, responseCallBack, errorCallBack) {
    this.method(
      "sendSalesOrderCustomerMail",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelPurchaseOrderReceiptLine(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "cancelPurchaseOrderReceiptLine",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unApproveSalesOrder(input, responseCallBack, errorCallBack) {
    this.method("unApproveSalesOrder", input, responseCallBack, errorCallBack);
  }
  static specialApproveSalesOrder(input, responseCallBack, errorCallBack) {
    this.method(
      "specialApproveSalesOrder",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static fetchPackingListMailDefaultInfoBean(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "fetchPackingListMailDefaultInfoBean",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static sendPackingListMail(input, responseCallBack, errorCallBack) {
    this.method("sendPackingListMail", input, responseCallBack, errorCallBack);
  }
  static getApprovedSalesOrderForMassPickTicketGenerartion(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getApprovedSalesOrderForMassPickTicketGenerartion",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateMassPickTicketGenerartion(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateMassPickTicketGenerartion",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static lockSalesOrder(input, responseCallBack, errorCallBack) {
    this.method("lockSalesOrder", input, responseCallBack, errorCallBack);
  }
  static cancelMassSalesOrder(input, responseCallBack, errorCallBack) {
    this.method("cancelMassSalesOrder", input, responseCallBack, errorCallBack);
  }
  static getOpenSalesOrderLinesForMassMaintenance(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getOpenSalesOrderLinesForMassMaintenance",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelMassSalesOrder(input, responseCallBack, errorCallBack) {
    this.method("cancelMassSalesOrder", input, responseCallBack, errorCallBack);
  }
  static getOpenSalesOrderLinesForMassMaintenance(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getOpenSalesOrderLinesForMassMaintenance",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static approveSalesOrder(input, responseCallBack, errorCallBack) {
    this.method("approveSalesOrder", input, responseCallBack, errorCallBack);
  }
  static getSalesOrderLinesForMassMaintenance(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getSalesOrderLinesForMassMaintenance",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static updateExistringSalesOrderDate(input, responseCallBack, errorCallBack) {
    this.method(
      "updateExistringSalesOrderDate",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateAdvancedMassPickTicketGenerartion(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateAdvancedMassPickTicketGenerartion",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getAdvancedApprovedSalesOrderForMassPickTicketGenerartion(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getAdvancedApprovedSalesOrderForMassPickTicketGenerartion",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  
    static checkInvoicesAvailableForSalesOrder(input, responseCallBack, errorCallBack) {
       this.method("checkInvoicesAvailableForSalesOrder", input, responseCallBack, errorCallBack);
     }  

  static salesOrderDocUpload(input, responseCallBack, errorCallBack) {
    this.method("salesOrderDocUpload", input, responseCallBack, errorCallBack);
  }

  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.so_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     //"Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
      ServiceExecutorProxy.executeService(methodName, input,this.so_data_url,responseCallBack, errorCallBack);
    }
  }
}
